// extracted by mini-css-extract-plugin
module.exports = {"pole-prices-popover":"PricesPopover_pole-prices-popover__2O6C3","content":"PricesPopover_content__17PxR","title":"PricesPopover_title__2bSoc"};